export const formatPaymentDisplay = (paymentMethod, collectionMethod, subMethod) => {
    let display = paymentMethod || 'N/A';
    
    if (paymentMethod === 'COD' && collectionMethod === 'ONLINE') {
        display = 'COD + ONLINE';
    } else if (collectionMethod && collectionMethod !== paymentMethod && collectionMethod !== 'PREPAID') {
        display = `${paymentMethod} + ${collectionMethod}`;
    }

    if (subMethod && subMethod.toUpperCase() !== 'ONLINE' && subMethod.toUpperCase() !== paymentMethod) {
        display += ` (${subMethod.toUpperCase()})`;
    }

    return display;
};
